module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "p-legal-notice"
  }, [_c('div', {
    staticClass: "p-legal-notice__container u-marg-x-auto u-w6of10 u-w8of10@xs"
  }, [_c('h1', [_c('span', {
    staticClass: "t-text--lg t-ffamily--domaine t-fweight--light",
    domProps: {
      "innerHTML": _vm._s(_vm.content.page_title)
    }
  })]), _vm._v(" "), _vm._l((_vm.content.blocks), function(block, index) {
    return _c('div', {
      staticClass: "p-legal-notice__container__block u-marg-t-xxl t-ffamily--domaine"
    }, [_c('h2', [_c('span', {
      staticClass: "t-text--sm t-ffamily--domaine t-fweight--light",
      domProps: {
        "innerHTML": _vm._s(block.title)
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "o-content u-marg-t-xxs t-text--sm t-lspacing--xxxs u-opacity--40",
      domProps: {
        "innerHTML": _vm._s(block.content)
      }
    })])
  })], 2), _vm._v(" "), _c('app-page-footer', {
    attrs: {
      "text": _vm.content.footer_text_content,
      "page": _vm.content.footer_page,
      "link-label": _vm.content.footer_page_label
    }
  }), _vm._v(" "), _c('app-footer')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3c3e0564"}!./src/scripts/components/page-legal-notice/template.html
// module id = 189
// module chunks = 0